/* ================================
   FULL TAXONOMY (Pillar → Topic → Sub-Question)
   ================================ */

/* ----- READING & WRITING ----- */
export const ENGLISH_PILLARS = [
  {
    id: "craft_and_structure",
    name: "Craft and Structure",
    pillarWeight: 0.28,
    topics: [
      {
        id: "wc",
        name: "Words in Context",
        topicWeight: 0.32,
        skills: [
          { id: "wc_lwc", code: "lwc", name: "Logical word choice", weight: 0.45 },
          { id: "wc_muc", code: "muc", name: "Meaning as used in context", weight: 0.35 },
          { id: "wc_ap",  code: "ap",  name: "Abstract precision", weight: 0.20 },
        ],
      },
      {
        id: "ts",
        name: "Text Structure",
        topicWeight: 0.28,
        skills: [
          { id: "ts_os",  code: "os",  name: "Overall structure", weight: 0.38 },
          { id: "ts_fsp", code: "fsp", name: "Function of a sentence or paragraph", weight: 0.34 },
          { id: "ts_lp",  code: "lp",  name: "Logical progression", weight: 0.28 },
        ],
      },
      {
        id: "tp",
        name: "Text Purpose",
        topicWeight: 0.18,
        skills: [
          { id: "tp_mpp", code: "mpp", name: "Main purpose of passage", weight: 0.45 },
          { id: "tp_agi", code: "agi", name: "Author's goal in presenting information", weight: 0.30 },
          { id: "tp_mpt", code: "mpt", name: "Main purpose of text as a whole", weight: 0.25 },
        ],
      },
      {
        id: "ctc",
        name: "Cross-Text Connections",
        topicWeight: 0.22,
        skills: [
          { id: "ctc_a", code: "a", name: "Agreement", weight: 0.30 },
          { id: "ctc_d", code: "d", name: "Disagreement", weight: 0.28 },
          { id: "ctc_r", code: "r", name: "Refinement", weight: 0.22 },
          { id: "ctc_c", code: "c", name: "Critique", weight: 0.20 },
        ],
      },
    ],
  },
  {
    id: "information_and_ideas",
    name: "Information and Ideas",
    pillarWeight: 0.26,
    topics: [
      {
        id: "cid",
        name: "Central Ideas and Details",
        topicWeight: 0.32,
        skills: [
          { id: "cid_mi", code: "mi", name: "Main idea", weight: 0.42 },
          { id: "cid_cd", code: "cd", name: "Central detail", weight: 0.33 },
          { id: "cid_ds", code: "ds", name: "Descriptive summary", weight: 0.25 },
        ],
      },
      {
        id: "inf",
        name: "Inferences",
        topicWeight: 0.28,
        skills: [
          { id: "inf_ti",  code: "ti",  name: "Textual inference", weight: 0.32 },
          { id: "inf_lc",  code: "lc",  name: "Logical completion", weight: 0.26 },
          { id: "inf_fah", code: "fah", name: "For or against hypothesis", weight: 0.22 },
          { id: "inf_mr",  code: "mr",  name: "Method reasoning", weight: 0.20 },
        ],
      },
      {
        id: "tce",
        name: "Textual Command of Evidence",
        topicWeight: 0.22,
        skills: [
          { id: "tce_qbs", code: "qbs", name: "Quote to best support a claim", weight: 0.58 },
          { id: "tce_sle", code: "sle", name: "Sentence-level evidence", weight: 0.42 },
        ],
      },
      {
        id: "qce",
        name: "Quantitative Command of Evidence",
        topicWeight: 0.18,
        skills: [
          { id: "qce_dc",  code: "dc",  name: "Data completion", weight: 0.28 },
          { id: "qce_ds",  code: "ds_q", name: "Data support", weight: 0.27 },
          { id: "qce_dt",  code: "dt",  name: "Data trend", weight: 0.23 },
          { id: "qce_cbg", code: "cbg", name: "Comparison between groups", weight: 0.22 },
        ],
      },
    ],
  },
  {
    id: "standard_english_conventions",
    name: "Standard English Conventions",
    pillarWeight: 0.26,
    topics: [
      {
        id: "b",
        name: "Boundaries",
        topicWeight: 0.44,
        skills: [
          { id: "b_pc", code: "pc", name: "Punctuation choice", weight: 0.40 },
          { id: "b_cc", code: "cc", name: "Conjunction choice", weight: 0.33 },
          { id: "b_rf", code: "rf", name: "Run-ons and fragments", weight: 0.27 },
        ],
      },
      {
        id: "f",
        name: "Form, Structure, and Sense",
        topicWeight: 0.56,
        skills: [
          { id: "f_vtf", code: "vtf", name: "Verb tense and form", weight: 0.22 },
          { id: "f_sva", code: "sva", name: "Subject-verb agreement", weight: 0.20 },
          { id: "f_pa",  code: "pa",  name: "Pronoun agreement", weight: 0.16 },
          { id: "f_wfp", code: "wfp", name: "Word form and possessives", weight: 0.15 },
          { id: "f_mmp", code: "mmp", name: "Misplaced modifier and parallelism", weight: 0.14 },
          { id: "f_pm",  code: "pm",  name: "Preserving meaning", weight: 0.13 },
        ],
      },
    ],
  },
  {
    id: "expression_of_ideas",
    name: "Expression of Ideas",
    pillarWeight: 0.20,
    topics: [
      {
        id: "t",
        name: "Transitions",
        topicWeight: 0.55,
        skills: [
          { id: "t_ce",  code: "ce",   name: "Cause or effect", weight: 0.20 },
          { id: "t_cc",  code: "cc_t", name: "Contrast or concession", weight: 0.19 },
          { id: "t_ar",  code: "ar",   name: "Addition or reinforcement", weight: 0.17 },
          { id: "t_es",  code: "es",   name: "Example or specificity", weight: 0.16 },
          { id: "t_st",  code: "st",   name: "Sequence or time", weight: 0.15 },
          { id: "t_cr",  code: "cr",   name: "Clarification or restatement", weight: 0.13 },
        ],
      },
      {
        id: "rs",
        name: "Rhetorical Synthesis",
        topicWeight: 0.45,
        skills: [
          { id: "rs_s",   code: "s",   name: "Specify", weight: 0.18 },
          { id: "rs_ex",  code: "ex",  name: "Explain", weight: 0.17 },
          { id: "rs_uqe", code: "uqe", name: "Use a quotation or evidence", weight: 0.16 },
          { id: "rs_sg",  code: "sg",  name: "Summarize or generalize", weight: 0.14 },
          { id: "rs_em",  code: "em",  name: "Emphasis", weight: 0.13 },
          { id: "rs_pi",  code: "pi",  name: "Present or introduce", weight: 0.11 },
          { id: "rs_cc",  code: "cc_r",  name: "Compare or contrast", weight: 0.11 },
        ],
      },
    ],
  },
];

/* ----- MATH ----- */
export const MATH_PILLARS = [
  {
    id: "algebra",
    name: "Algebra",
    pillarWeight: 0.35,
    topics: [
      {
        id: "1vle",
        name: "1 Variable Linear Equations",
        topicWeight: 0.20,
        skills: [
          { id: "1vle_sle", code: "sle", name: "Solve linear equation", weight: 0.40 },
          { id: "1vle_eeq", code: "eeq", name: "Equivalent equations", weight: 0.25 },
          { id: "1vle_svc", code: "svc", name: "Solve for variable in context", weight: 0.20 },
          { id: "1vle_sfe", code: "sfe", name: "Solve for expression", weight: 0.15 },
        ],
      },
      {
        id: "2vle",
        name: "2 Variable Linear Equations",
        topicWeight: 0.18,
        skills: [
          { id: "2vle_wec", code: "wec", name: "Write equation from context", weight: 0.55 },
          { id: "2vle_eop", code: "eop", name: "Check ordered pair solution", weight: 0.45 },
        ],
      },
      {
        id: "lf",
        name: "Linear Functions",
        topicWeight: 0.22,
        skills: [
          { id: "lf_sc", code: "sc", name: "Slope calculation", weight: 0.20 },
          { id: "lf_si", code: "si", name: "Slope interpretation", weight: 0.18 },
          { id: "lf_yic", code: "yic", name: "Y-intercept calculation", weight: 0.18 },
          { id: "lf_yii", code: "yii", name: "Y-intercept interpretation", weight: 0.16 },
          { id: "lf_wet", code: "wet", name: "Write equation from table", weight: 0.15 },
          { id: "lf_weg", code: "weg", name: "Write equation from graph", weight: 0.13 },
        ],
      },
      {
        id: "lse",
        name: "Linear Systems of Equations",
        topicWeight: 0.22,
        skills: [
          { id: "lse_ssa", code: "ssa", name: "Solve system algebraically", weight: 0.30 },
          { id: "lse_ssg", code: "ssg", name: "Solve system graphically", weight: 0.20 },
          { id: "lse_sfc", code: "sfc", name: "System from context", weight: 0.15 },
          { id: "lse_nos", code: "nos", name: "Number of solutions", weight: 0.12 },
          { id: "lse_nsc", code: "nsc", name: "No-solution condition", weight: 0.12 },
          { id: "lse_isc", code: "isc", name: "Infinite-solution condition", weight: 0.11 },
        ],
      },
      {
        id: "li",
        name: "Linear Inequalities",
        topicWeight: 0.18,
        skills: [
          { id: "li_sineq", code: "sineq", name: "Solve inequality", weight: 0.35 },
          { id: "li_mcc", code: "mcc", name: "Model constraint from context", weight: 0.35 },
          { id: "li_tvt", code: "tvt", name: "Test values or tables", weight: 0.30 },
        ],
      },
    ],
  },
  {
    id: "advanced_math",
    name: "Advanced Math",
    pillarWeight: 0.35,
    topics: [
      {
        id: "ee",
        name: "Equivalent Expressions",
        topicWeight: 0.30,
        skills: [
          { id: "ee_fac", code: "fac", name: "Factoring", weight: 0.25 },
          { id: "ee_exp", code: "exp", name: "Expansion", weight: 0.25 },
          { id: "ee_er", code: "er", name: "Exponent rules", weight: 0.20 },
          { id: "ee_res", code: "res", name: "Rational expression simplification", weight: 0.20 },
          { id: "ee_sfi", code: "sfi", name: "Structural factor identification", weight: 0.10 },
        ],
      },
      {
        id: "1vne",
        name: "1 Variable Nonlinear Equations",
        topicWeight: 0.25,
        skills: [
          { id: "1vne_qe", code: "qe", name: "Quadratic equations", weight: 0.50 },
          { id: "1vne_ave", code: "ave", name: "Absolute value equations", weight: 0.20 },
          { id: "1vne_xeq", code: "xeq", name: "Exponential equations", weight: 0.20 },
          { id: "1vne_nos", code: "nos_nl", name: "Number of solutions", weight: 0.10 },
        ],
      },
      {
        id: "nse",
        name: "Nonlinear Systems of Equations",
        topicWeight: 0.18,
        skills: [
          { id: "nse_lqs", code: "lqs", name: "Linear-quadratic systems", weight: 0.60 },
          { id: "nse_nss", code: "nss", name: "No-solution systems", weight: 0.40 },
        ],
      },
      {
        id: "nf",
        name: "Nonlinear Functions",
        topicWeight: 0.27,
        skills: [
          { id: "nf_vi", code: "vi", name: "Vertex interpretation", weight: 0.25 },
          { id: "nf_mmv", code: "mmv", name: "Minimum or maximum value", weight: 0.25 },
          { id: "nf_ft", code: "ft", name: "Function transformations", weight: 0.20 },
          { id: "nf_egd", code: "egd", name: "Exponential growth and decay", weight: 0.20 },
          { id: "nf_dht", code: "dht", name: "Doubling or halving time", weight: 0.10 },
        ],
      },
    ],
  },
  {
    id: "problem_solving_and_data_analysis",
    name: "Problem-Solving and Data Analysis",
    pillarWeight: 0.15,
    topics: [
      {
        id: "rrru",
        name: "Ratios, Rates, Proportional Relationships, and Units",
        topicWeight: 0.25,
        skills: [
          { id: "rrru_uc", code: "uc", name: "Unit conversion", weight: 0.30 },
          { id: "rrru_ur", code: "ur", name: "Unit rates", weight: 0.25 },
          { id: "rrru_pr", code: "pr", name: "Proportional reasoning", weight: 0.30 },
          { id: "rrru_sf", code: "sf", name: "Scale factors", weight: 0.15 },
        ],
      },
      {
        id: "1vd",
        name: "Percentages and 1 Variable Data",
        topicWeight: 0.20,
        skills: [
          { id: "1vd_poq", code: "poq", name: "Percent of a quantity", weight: 0.30 },
          { id: "1vd_pid", code: "pid", name: "Percent increase or decrease", weight: 0.30 },
          { id: "1vd_mean", code: "mean", name: "Mean", weight: 0.20 },
          { id: "1vd_med", code: "med", name: "Median", weight: 0.20 },
        ],
      },
      {
        id: "2vd",
        name: "2 Variable Data",
        topicWeight: 0.20,
        skills: [
          { id: "2vd_sp", code: "sp", name: "Scatterplots", weight: 0.25 },
          { id: "2vd_lbf", code: "lbf", name: "Line of best fit", weight: 0.35 },
          { id: "2vd_sfd", code: "sfd", name: "Slope from data", weight: 0.20 },
          { id: "2vd_pfm", code: "pfm", name: "Prediction from model", weight: 0.20 },
        ],
      },
      {
        id: "prob",
        name: "Probability",
        topicWeight: 0.15,
        skills: [
          { id: "prob_simp", code: "simp", name: "Simple probability", weight: 0.45 },
          { id: "prob_pft", code: "pft", name: "Probability from tables", weight: 0.55 },
        ],
      },
      {
        id: "is",
        name: "Inference from stats",
        topicWeight: 0.10,
        skills: [
          { id: "is_evs", code: "evs", name: "Expected value from sample", weight: 0.50 },
          { id: "is_sps", code: "sps", name: "Sample-to-population scaling", weight: 0.50 },
        ],
      },
      {
        id: "esc",
        name: "Evaluating statistical claims",
        topicWeight: 0.10,
        skills: [
          { id: "esc_cva", code: "cva", name: "Cause vs association", weight: 0.50 },
          { id: "esc_voc", code: "voc", name: "Validity of conclusions", weight: 0.50 },
        ],
      },
    ],
  },
  {
    id: "geometry_and_trigonometry",
    name: "Geometry and Trigonometry",
    pillarWeight: 0.15,
    topics: [
      {
        id: "av",
        name: "Area and volume",
        topicWeight: 0.35,
        skills: [
          { id: "av_area", code: "area", name: "Area", weight: 0.30 },
          { id: "av_per", code: "per", name: "Perimeter", weight: 0.15 },
          { id: "av_vol", code: "vol", name: "Volume", weight: 0.30 },
          { id: "av_se", code: "se", name: "Scaling effects", weight: 0.15 },
          { id: "av_cf", code: "cf", name: "Composite figures", weight: 0.10 },
        ],
      },
      {
        id: "latt",
        name: "Lines, angles, triangles, and trig",
        topicWeight: 0.40,
        skills: [
          { id: "latt_ar", code: "ar", name: "Angle relationships", weight: 0.15 },
          { id: "latt_plt", code: "plt", name: "Parallel lines and transversals", weight: 0.12 },
          { id: "latt_tsim", code: "tsim", name: "Triangle similarity", weight: 0.15 },
          { id: "latt_tcon", code: "tcon", name: "Triangle congruence", weight: 0.10 },
          { id: "latt_pt", code: "pt", name: "Pythagorean theorem", weight: 0.18 },
          { id: "latt_srt", code: "srt", name: "Special right triangles", weight: 0.10 },
          { id: "latt_tr", code: "tr", name: "Trigonometric ratios", weight: 0.15 },
          { id: "latt_tir", code: "tir", name: "Trig identity reasoning", weight: 0.05 },
        ],
      },
      {
        id: "c",
        name: "Circles",
        topicWeight: 0.25,
        skills: [
          { id: "c_ec", code: "ec", name: "Equation of a circle", weight: 0.25 },
          { id: "c_cri", code: "cri", name: "Center and radius identification", weight: 0.20 },
          { id: "c_drr", code: "drr", name: "Diameter and radius relationships", weight: 0.15 },
          { id: "c_al", code: "al", name: "Arc length", weight: 0.15 },
          { id: "c_arq", code: "arq", name: "Arc ratios", weight: 0.10 },
          { id: "c_ct", code: "ct", name: "Circle transformations", weight: 0.10 },
          { id: "c_if", code: "if", name: "Inscribed figures", weight: 0.05 },
        ],
      },
    ],
  },
];
